export default __webpack_public_path__ + "static/media/LauraKlein.e324c794.jpg";